import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TodoService } from '../todo.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import * as moment from 'moment';
import { Preference } from '../preference.model';
import { OrganizationServices } from 'app/main/shared/services/organization.services';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
  selector: 'todo-details',
  templateUrl: './todo-details.component.html',
  styleUrls: ['./todo-details.component.scss']
})
export class TodoDetailsComponent implements OnInit {

  isLoading = false;
  progress = true;
  projects = [];

  selectedProject: any;
  userId: string;
  userRole;
  count: number;

  firstTime: boolean = true;

  defaultProjects = [
    {
      id: '1',
      icon: 'wb_sunny',
      name: 'My Day',
      preference: {
        type: '',
        value: true
      }
    },
    {
      id: '2',
      icon: 'star_border',
      name: 'Important',
      preference: {
        type: 'important_on',
        value: true
      }
    },
    {
      id: '3',
      icon: 'event_note',
      name: 'Planned',
      preference: {
        type: 'planned_on',
        value: true
      }
    },
    {
      id: '4',
      icon: 'flag',
      name: 'Priority',
      preference: {
        type: 'priority_on',
        value: true
      }
    },
    {
      id: '5',
      icon: 'person_outline',
      name: 'Assigned To Me',
      preference: {
        type: 'assigned_to_me_on',
        value: true
      }
    }
  ]

  @ViewChild('newProject') newProject: ElementRef;
  preference: Preference;

  constructor(
    private todoService: TodoService,
    private organizationServices: OrganizationServices,
    private localUser: LocalUserService,
    private headerService: HeaderTitleService
  ) {
    this.selectedProject = this.defaultProjects[0];
    this.userRole = this.localUser.getRole();
    this.userId = this.localUser.getUserId();
  }

  ngOnInit() {
    this.getAllProject();
    this.getPreferences();
    setTimeout(() => { this.sendHeaders(); });
  }
  sendHeaders(): void {
    this.headerService.sendHeader('check_circle', 'ToDo')
  }

  createProject(name: string | any) {
    if (!name) { return }
    let projectData = {
      name: name,
      sort_order: 1,
    };
    this.todoService.createProject(this.userId, projectData).subscribe(data => {
      this.newProject.nativeElement.value = '';
      if (data) {
        this.selectedProject = data;
        this.getAllProject();
      }
    });

  }

  getAllProject() {
    this.isLoading = true;
    this.todoService.getAllProjects(this.userId)
      .subscribe((items) => {
        this.projects = items;
        if (this.projects && this.projects.length) {
          // this.selectedProject = null
          this.selectProjectByDefualt();
        }

        this.isLoading = false;
      }, (err) => console.log(err));
  }

  getPreferences() {
    this.isLoading = true;
    this.todoService.getPreferences(this.userId)
      .subscribe((items) => {
        this.preference = items;
        this.setDefaultProjectsPerference();
        this.isLoading = false;
      }, (err) => console.log(err));
  }

  setDefaultProjectsPerference() {
    this.isLoading = true;
    this.defaultProjects.forEach((project) => {
      if (project.preference.type) {
        project.preference.value = this.preference[project.preference.type]
      }
      this.isLoading = false;
    })
  }

  showMe(item) {
    if (this.preference.auto_hide_empty_list_on) {
      if (item.name == 'My Day') { return true; }
      let taskLength = this.getCount(item);
      return !!(taskLength && item.preference.value);
    }
    return item.preference.value;
  }
  selectProjectByDefualt() {
    this.isLoading = true;
    if (this.firstTime) {
      let project = this.projects.find(project => project.default);
      this.selectedProject = project || this.selectedProject;
      this.firstTime = false;
    } else {
      let project = this.projects.find(project => project.id === this.selectedProject.id)
      this.selectedProject = project || this.projects[0];
    }
    this.isLoading = false;
  }



  getCount(list) {
    if (!this.projects || !this.projects.length) { return null }

    this.count = 0
    this.projects.forEach(project => {
      project.tasks.forEach(task => {
        if (task.starred && list.name.toLowerCase() === 'important' && !task.is_completed) {
          this.count = this.count + 1;
        } else if (task.due_date && list.name.toLowerCase() === 'planned' && !task.is_completed) {
          this.count = this.count + 1;
        } else if (task.my_day && moment(task.my_day).isSame(moment(), 'day') && list.name.toLowerCase() === 'my day' && !task.is_completed) {
          this.count = this.count + 1;
        } else if (task.priority && list.name.toLowerCase() === 'priority' && !task.is_completed) {
          this.count = this.count + 1;
        }
      })
    })
    return this.count ? this.count : null;
  }
  getDueCount(list) {
    let currentdate = new Date()
    if (!this.projects || !this.projects.length) { return null }

    this.count = 0
    this.projects.forEach(project => {
      project.tasks.forEach(task => {
        if (task.starred && list.name.toLowerCase() === 'important' && !task.is_completed && task.due_date && moment(task.due_date).startOf('day') < moment(currentdate).startOf('day')) {
          this.count = this.count + 1;
        } else if (task.due_date && list.name.toLowerCase() === 'planned' && !task.is_completed && task.due_date && moment(task.due_date).startOf('day') < moment(currentdate).startOf('day')) {
          this.count = this.count + 1;
        } else if (task.my_day && moment(task.my_day).isSame(moment(), 'day') && list.name.toLowerCase() === 'my day' && !task.is_completed && task.due_date && moment(task.due_date).startOf('day') < moment(currentdate).startOf('day')) {
          this.count = this.count + 1;
        } else if (task.priority && list.name.toLowerCase() === 'priority' && !task.is_completed && task.due_date && moment(task.due_date).startOf('day') < moment(currentdate).startOf('day')) {
          this.count = this.count + 1;
        }
      })
    })
    return this.count ? this.count : null;
  }

  // getTaskCount() {
  //   let alltask = []
  //   this.projects.forEach(project => alltask.push(...project.tasks));
  //   return alltask.length;
  // }

  getCompletedTask(tasks) {
    let count = tasks.filter(task => !task.is_completed).length
    return count ? count : null;
  }
  getDueTask(tasks) {
    let currentdate = new Date();
    let count = tasks.filter(task => !task.is_completed && task.due_date && moment(task.due_date).startOf('day') < moment(currentdate).startOf('day')).length
    return count ? count : null;
  }

  onRemove() {
    this.firstTime = true;
    this.selectedProject = null;
    this.getAllProject();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-details/todo-details.component.ts